<template lang="html">
  <div class="vacuo">
    <img class="vacuoImg" src="@/assets/image/activity/cite/poster.jpg">
    <div class="footerMod" @click="getAttendMeetings">
      <p>我要参会</p>
    </div>
  </div>
</template>

<script>
	import { pagebase } from '@/utils/http.js';
	import WxShare from '@/utils/wxshare';

  export default {
    data() {
			return {
				pagebase: pagebase,
			}
		},
    mounted() {
      window.scroll(0, 0);
      document.title = '【报名参会】2025中国半导体制造技术创新与供应链大会';
      this.init();
    },

    methods: {
      init(){
				this.wxshare = new WxShare();
				this.wxshare.share({
					title: '【报名参会】2025中国半导体制造技术创新与供应链大会',
					desc: '诚邀您共筑智链芯未来，大会将于今年4月10日14:00在深圳会展中心(福田)举办。',
					link: window.location.href,
					imgUrl: pagebase + '/static/img/cite.jpg',
				})
			},

      getAttendMeetings() {
        window.location.href = 'https://www.wjx.cn/vm/tUFvo5q.aspx#';
      }
    }
  }
</script>

<style lang="css" scoped>
  .vacuo {
    width: 100%;
    background-color: #1e1c89;
  }

  .vacuoImg {
    width: 100%;
    object-fit: cover;
  }

  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .footerMod p {
    width: 15rem;
    padding: 1rem  0;
    border-radius: 4rem;
    background-color: red;
    color: #FFF;
    font-size: 1.8rem;
  }
</style>